/**
 * ShapeNode — Rectangle, circle, or diamond shape with context menu
 */

import { useState } from 'react';
import { Handle, Position } from '@xyflow/react';

const SHAPE_COLORS = ['#E0E7FF', '#DBEAFE', '#D1FAE5', '#FEF3C7', '#FDE68A', '#FCE7F3', '#FEE2E2', '#1F2937'];

export default function ShapeNode({ data, selected, id }) {
  const [showMenu, setShowMenu] = useState(false);
  const shape = data.shape || 'rectangle';
  const color = data.color || '#E0E7FF';
  const size = data.size || 80;

  const shapeStyles = {
    rectangle: { width: size * 1.4, height: size, borderRadius: 8 },
    circle: { width: size, height: size, borderRadius: '50%' },
    diamond: { width: size, height: size, borderRadius: 8, transform: 'rotate(45deg)' },
  };

  return (
    <div className="relative group" style={{ width: shapeStyles[shape].width, height: shapeStyles[shape].height }}>
      <Handle type="target" position={Position.Top} className="!w-2 !h-2 !bg-gray-400" />
      <Handle type="source" position={Position.Bottom} className="!w-2 !h-2 !bg-gray-400" />
      <Handle type="target" position={Position.Left} className="!w-2 !h-2 !bg-gray-400" />
      <Handle type="source" position={Position.Right} className="!w-2 !h-2 !bg-gray-400" />

      <div className={`w-full h-full border-2 ${selected ? 'border-blue-500' : 'border-gray-300'}`}
        style={{ ...shapeStyles[shape], backgroundColor: color }} />

      {/* Menu */}
      <div className="absolute -top-1 -right-1 z-10">
        <button onClick={(e) => { e.stopPropagation(); setShowMenu(!showMenu); }}
          className="p-1 rounded opacity-0 group-hover:opacity-100 hover:bg-black/20 transition-opacity">
          <svg className="w-3.5 h-3.5 text-gray-500" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></svg>
        </button>
        {showMenu && (
          <>
            <div className="fixed inset-0 z-20" onClick={() => setShowMenu(false)} />
            <div className="absolute right-0 top-6 w-36 bg-white rounded-lg shadow-xl border border-gray-200 py-1 z-30">
              <div className="px-3 py-1.5">
                <div className="text-[10px] text-gray-400 mb-1">Color</div>
                <div className="flex gap-1 flex-wrap">
                  {SHAPE_COLORS.map(c => (
                    <button key={c} onClick={() => { data.onColorChange?.(id, c); setShowMenu(false); }}
                      className={`w-4 h-4 rounded-full border ${color === c ? 'border-gray-600 ring-1 ring-blue-400' : 'border-gray-300'}`}
                      style={{ backgroundColor: c }} />
                  ))}
                </div>
              </div>
              <div className="border-t border-gray-100 my-1" />
              <button onClick={() => { data.onDelete?.(id); setShowMenu(false); }}
                className="w-full px-3 py-1.5 text-xs text-red-600 hover:bg-red-50 text-left">Delete</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
